module.exports = __webpack_public_path__ + "static/bnr_wide@3x-4bcc433ad145623a7845c05515c85907.webp";